export function dynamicLocaleCompareWithOptions(o1,o2,prop,isNumeric= true,language ='de'){
    return o1[prop].localeCompare(o2[prop],language,{numeric:isNumeric});
}

export function dynamicLocaleCompare(o1,o2,prop){
    return o1[prop].localeCompare(o2[prop]);
}